
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/purchase",
      function () {
        return require("private-next-pages/purchase.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/purchase"])
      });
    }
  